export function delay<T = undefined>(delayMs: number, value?: T): Promise<T | undefined> {
  return new Promise<T | undefined>((res) => {
    window.setTimeout(() => res(value), delayMs)
  })
}

export async function wait<T>(promise: Promise<T>, waitLimit = 400): Promise<T | void> {
  try {
    return await Promise.race([promise, delay(waitLimit)])
  } catch (error) {
    return Promise.resolve()
  }
}

export async function waitGnar<T>(promise: Promise<T>): Promise<T | void> {
  return wait(promise, 100)
}
